var React = require('react');

function IconMagInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#005285","fillRule":"nonzero"},React.createElement("path",{"d":"M5.846 11.692A5.846 5.846 0 1 1 5.846 0a5.846 5.846 0 0 1 0 11.692zm0-.852a4.994 4.994 0 1 0 0-9.987 4.994 4.994 0 0 0 0 9.987zM10.83 10.83a.82.82 0 0 1 1.158 0l3.322 3.322a.82.82 0 0 1-1.158 1.158l-3.322-3.322a.82.82 0 0 1 0-1.158z"})));
}

IconMagInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = IconMagInline;

IconMagInline.default = IconMagInline;
